// Every link the app points to, defined once. Import from here instead of
// hard-coding a URL or email in a component.

// Pages inside this app (see routes.js for the layout + path each is served under).
export const ROUTES = {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    // Same sign-up form and trial, NHS/work emails only — the link sent to NHS users.
    NHS_REGISTER: '/auth/nhs-register',
    RESET_PASSWORD: '/auth/reset-password',
    NEW_CHAT: '/c/',
    chat: (id) => `/c/${id}`,
    ABOUT_US: '/about-us',
    PRIVACY: '/privacy',
    TERMS: '/terms',
    FAQ: '/faq',
    USER_GUIDE: '/user-guide',
    FEEDBACK: '/feedback',
};

export const EXTERNAL_LINKS = {
    BEVAN_HOME: 'https://bevan.ai/',
    FHI_HOME: 'https://futurehealthintelligence.com/',
    FHI_SUBSCRIPTION_OPTIONS: 'https://futurehealthintelligence.com/subscription-options/',
    FEEDBACK_SURVEY: 'https://www.surveymonkey.com/r/J976QG6',
    ICO_LEGITIMATE_INTERESTS: 'https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/lawful-basis/a-guide-to-lawful-basis/lawful-basis-for-processing/legitimate-interests/',
};

export const EMAILS = {
    // Demo requests from people without an account.
    INTELLIGENCE: 'intelligence@futurehealthintelligence.com',
    // Feedback, feature suggestions and support.
    SUPPORT: 'Team@bevan.ai',
    // Data protection and privacy policy questions.
    PRIVACY: 'michele@futurehealthintelligence.com',
};

export const mailto = (email) => `mailto:${email}`;
